export const sectionHintSearchPlugin = {
  getSources({ refresh }) {
    return [
      {
        sourceId: 'sectionHintSearchPlugin',
        async getItems() {
          if (window.cece.searchSection) {
            return [{ title: `${window.i18n.header.searchSearchingIn} ${window.i18n.currentSection}` }];
          }
          return [];
        },
        templates: {
          item({ item, createElement }) {
            return createElement(
              'div',
              { class: 'catalog-search-item section-pre-filter' },
              // Content
              createElement('span', { class: 'content' }, item.title),
              // Action icons
              createElement(
                'span',
                {
                  class: 'actions',
                },
                // Remove button
                createElement('span', {
                  title: window.i18n.header.searchInWholeCatalog,
                  onClick: event => {
                    event.preventDefault();
                    event.stopPropagation();
                    window.cece.searchSection = null;
                    refresh();
                  },
                  dangerouslySetInnerHTML: {
                    __html: `<svg width="16" height="16" class="cece-icon icon-close" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15 15 8 8l7-7M1 15l7-7-7-7" stroke="#000" stroke-linecap="round"/></svg>`,
                  },
                })
              )
            );
          },
        },
      },
    ];
  },
};
